var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 556,
    height: 255,
    viewBox: "0 0 556 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1618_12929)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 254.46,
    rx: 4.48387,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1618_12929)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 40.3548,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H159.177V40.3548H0V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H159.177V40.3548H0V0Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-1.12097H-1.12097V0H0ZM0 1.12097H159.177V-1.12097H0V1.12097ZM1.12097 40.3548V0H-1.12097V40.3548H1.12097Z",
    fill: "#A6A6A6",
    mask: "url(#path-3-inside-1_1618_12929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1829 13.53V26.2109H59.1511L53.1435 17.541H53.0384V26.2109H50.7614V13.53H52.8282L58.8008 22.2H58.9235V13.53H61.1829ZM67.5759 26.4036C64.8085 26.4036 63.022 24.4419 63.022 21.4994C63.022 18.5393 64.8085 16.5776 67.5759 16.5776C70.3608 16.5776 72.1299 18.5393 72.1299 21.4994C72.1299 24.4419 70.3608 26.4036 67.5759 26.4036ZM67.5934 24.6171C69.1173 24.6171 69.8704 23.2334 69.8704 21.4819C69.8704 19.7479 69.1173 18.3466 67.5934 18.3466C66.0346 18.3466 65.2814 19.7479 65.2814 21.4819C65.2814 23.2334 66.0346 24.6171 67.5934 24.6171ZM73.8638 26.2109V16.7002H76.0357V18.2766H76.1408C76.4736 17.1907 77.4019 16.5601 78.4878 16.5601C78.7331 16.5601 79.0834 16.5776 79.2935 16.6127V18.6794C79.1009 18.6094 78.628 18.5393 78.2601 18.5393C77.0166 18.5393 76.1058 19.3976 76.1058 20.6061V26.2109H73.8638ZM80.6247 26.2109V16.7002H82.7615V18.3116H82.8841C83.2695 17.2257 84.2328 16.5776 85.4939 16.5776C86.79 16.5776 87.7008 17.2257 88.0686 18.3116H88.1737C88.5941 17.2607 89.645 16.5776 91.0287 16.5776C92.7627 16.5776 93.9887 17.6986 93.9887 19.8179V26.2109H91.7643V20.1682C91.7643 18.9772 91.0462 18.4517 90.1354 18.4517C89.0319 18.4517 88.4014 19.2049 88.4014 20.2733V26.2109H86.2295V20.0806C86.2295 19.0998 85.5639 18.4517 84.6181 18.4517C83.6548 18.4517 82.8666 19.2399 82.8666 20.4309V26.2109H80.6247ZM95.6877 23.5311C95.6877 21.3943 97.4567 20.7637 99.2257 20.6586C99.8826 20.6149 101.249 20.536 101.66 20.5185V19.7654C101.66 18.8196 101.047 18.2766 99.9439 18.2766C98.9455 18.2766 98.3325 18.732 98.1573 19.4151H96.003C96.1606 17.8037 97.6144 16.5776 99.9964 16.5776C101.8 16.5776 103.885 17.3133 103.885 19.8529V26.2109H101.748V24.8973H101.678C101.257 25.703 100.364 26.4036 98.8754 26.4036C97.0539 26.4036 95.6877 25.4052 95.6877 23.5311ZM97.842 23.5136C97.842 24.3368 98.5076 24.7572 99.4534 24.7572C100.802 24.7572 101.678 23.8639 101.678 22.7955V22.0073C101.266 22.0336 100.023 22.1212 99.576 22.1474C98.5076 22.235 97.842 22.6729 97.842 23.5136ZM108.229 13.53V26.2109H105.987V13.53H108.229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.178 0H318.355V40.3548H159.178V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.178 0H318.355V40.3548H159.178V0Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.178 0V-1.12097H158.057V0H159.178ZM159.178 1.12097H318.355V-1.12097H159.178V1.12097ZM160.299 40.3548V0H158.057V40.3548H160.299Z",
    fill: "#A6A6A6",
    mask: "url(#path-6-inside-2_1618_12929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.861 13.53V26.2109H172.829L166.821 17.541H166.716V26.2109H164.439V13.53H166.506L172.479 22.2H172.601V13.53H174.861ZM181.324 26.4036C178.451 26.4036 176.7 24.4945 176.7 21.5169C176.7 18.5743 178.486 16.5776 181.201 16.5776C183.531 16.5776 185.545 18.0314 185.545 21.3768V22.0774H178.907C178.933 23.6975 179.887 24.6521 181.341 24.6521C182.322 24.6521 182.988 24.2317 183.268 23.6712H185.457C185.054 25.3177 183.531 26.4036 181.324 26.4036ZM178.924 20.5536H183.408C183.39 19.2574 182.532 18.3116 181.236 18.3116C179.887 18.3116 178.994 19.3363 178.924 20.5536ZM191.5 26.4036C188.628 26.4036 186.876 24.4945 186.876 21.5169C186.876 18.5743 188.663 16.5776 191.377 16.5776C193.707 16.5776 195.721 18.0314 195.721 21.3768V22.0774H189.083C189.109 23.6975 190.064 24.6521 191.518 24.6521C192.498 24.6521 193.164 24.2317 193.444 23.6712H195.634C195.231 25.3177 193.707 26.4036 191.5 26.4036ZM189.1 20.5536H193.584C193.567 19.2574 192.709 18.3116 191.412 18.3116C190.064 18.3116 189.17 19.3363 189.1 20.5536ZM200.993 26.3861C198.751 26.3861 197.07 24.5995 197.07 21.4643C197.07 18.2941 198.804 16.5776 201.011 16.5776C202.692 16.5776 203.393 17.576 203.726 18.2591H203.813V13.53H206.038V26.2109H203.848V24.7046H203.726C203.375 25.4052 202.64 26.3861 200.993 26.3861ZM201.606 24.547C203.042 24.547 203.866 23.3034 203.866 21.4468C203.866 19.6077 203.06 18.3992 201.606 18.3992C200.117 18.3992 199.347 19.6778 199.347 21.4468C199.347 23.2509 200.135 24.547 201.606 24.547ZM217.37 16.7002V18.4167H215.408V26.2109H213.166V18.4167H211.747V16.7002H213.166V15.7894C213.166 13.9328 214.322 12.9345 216.144 12.9345C216.669 12.9345 217.142 12.987 217.562 13.0746V14.8436C217.195 14.7911 216.914 14.7736 216.757 14.7736C215.846 14.7736 215.408 15.1414 215.408 15.9996V16.7002H217.37ZM222.747 26.4036C219.98 26.4036 218.193 24.4419 218.193 21.4994C218.193 18.5393 219.98 16.5776 222.747 16.5776C225.532 16.5776 227.301 18.5393 227.301 21.4994C227.301 24.4419 225.532 26.4036 222.747 26.4036ZM222.764 24.6171C224.288 24.6171 225.041 23.2334 225.041 21.4819C225.041 19.7479 224.288 18.3466 222.764 18.3466C221.206 18.3466 220.452 19.7479 220.452 21.4819C220.452 23.2334 221.206 24.6171 222.764 24.6171ZM229.035 26.2109V16.7002H231.207V18.2766H231.312C231.645 17.1907 232.573 16.5601 233.659 16.5601C233.904 16.5601 234.254 16.5776 234.465 16.6127V18.6794C234.272 18.6094 233.799 18.5393 233.431 18.5393C232.188 18.5393 231.277 19.3976 231.277 20.6061V26.2109H229.035ZM239.614 23.5311C239.614 21.3943 241.383 20.7637 243.152 20.6586C243.809 20.6149 245.175 20.536 245.587 20.5185V19.7654C245.587 18.8196 244.974 18.2766 243.87 18.2766C242.872 18.2766 242.259 18.732 242.084 19.4151H239.929C240.087 17.8037 241.541 16.5776 243.923 16.5776C245.727 16.5776 247.811 17.3133 247.811 19.8529V26.2109H245.674V24.8973H245.604C245.184 25.703 244.291 26.4036 242.802 26.4036C240.98 26.4036 239.614 25.4052 239.614 23.5311ZM241.768 23.5136C241.768 24.3368 242.434 24.7572 243.38 24.7572C244.728 24.7572 245.604 23.8639 245.604 22.7955V22.0073C245.193 22.0336 243.949 22.1212 243.502 22.1474C242.434 22.235 241.768 22.6729 241.768 23.5136ZM254.66 16.7002V18.4167H252.785V23.356C252.785 24.2668 253.241 24.4594 253.801 24.4594C254.064 24.4594 254.502 24.4419 254.782 24.4244V26.246C254.519 26.2985 254.082 26.3335 253.521 26.3335C251.84 26.3335 250.543 25.5103 250.561 23.7238V18.4167H249.195V16.7002H250.561V14.4233H252.785V16.7002H254.66ZM261.123 16.7002V18.4167H259.248V23.356C259.248 24.2668 259.704 24.4594 260.264 24.4594C260.527 24.4594 260.965 24.4419 261.245 24.4244V26.246C260.982 26.2985 260.545 26.3335 259.984 26.3335C258.303 26.3335 257.007 25.5103 257.024 23.7238V18.4167H255.658V16.7002H257.024V14.4233H259.248V16.7002H261.123ZM266.955 26.4036C264.083 26.4036 262.331 24.4945 262.331 21.5169C262.331 18.5743 264.118 16.5776 266.833 16.5776C269.162 16.5776 271.176 18.0314 271.176 21.3768V22.0774H264.538C264.564 23.6975 265.519 24.6521 266.973 24.6521C267.954 24.6521 268.619 24.2317 268.899 23.6712H271.089C270.686 25.3177 269.162 26.4036 266.955 26.4036ZM264.556 20.5536H269.039C269.022 19.2574 268.164 18.3116 266.868 18.3116C265.519 18.3116 264.626 19.3363 264.556 20.5536ZM275.152 20.6411V26.2109H272.91V16.7002H275.047V18.3116H275.17C275.608 17.2432 276.571 16.5776 277.99 16.5776C279.969 16.5776 281.265 17.8737 281.247 20.1507V26.2109H279.023V20.501C279.023 19.2224 278.34 18.4693 277.166 18.4693C275.975 18.4693 275.152 19.2574 275.152 20.6411ZM288.131 16.7002V18.4167H286.257V23.356C286.257 24.2668 286.712 24.4594 287.273 24.4594C287.535 24.4594 287.973 24.4419 288.254 24.4244V26.246C287.991 26.2985 287.553 26.3335 286.992 26.3335C285.311 26.3335 284.015 25.5103 284.032 23.7238V18.4167H282.666V16.7002H284.032V14.4233H286.257V16.7002H288.131ZM289.847 26.2109V16.7002H292.089V26.2109H289.847ZM290.986 15.3516C290.285 15.3516 289.69 14.8086 289.69 14.1255C289.69 13.4599 290.285 12.917 290.986 12.917C291.704 12.917 292.282 13.4599 292.282 14.1255C292.282 14.8086 291.704 15.3516 290.986 15.3516ZM298.377 26.4036C295.61 26.4036 293.823 24.4419 293.823 21.4994C293.823 18.5393 295.61 16.5776 298.377 16.5776C301.162 16.5776 302.931 18.5393 302.931 21.4994C302.931 24.4419 301.162 26.4036 298.377 26.4036ZM298.395 24.6171C299.919 24.6171 300.672 23.2334 300.672 21.4819C300.672 19.7479 299.919 18.3466 298.395 18.3466C296.836 18.3466 296.083 19.7479 296.083 21.4819C296.083 23.2334 296.836 24.6171 298.395 24.6171ZM306.907 20.6411V26.2109H304.665V16.7002H306.802V18.3116H306.925C307.363 17.2432 308.326 16.5776 309.745 16.5776C311.724 16.5776 313.02 17.8737 313.002 20.1507V26.2109H310.778V20.501C310.778 19.2224 310.095 18.4693 308.921 18.4693C307.73 18.4693 306.907 19.2574 306.907 20.6411Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-3_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.23 0H555.997V40.3548H317.23V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.23 0H555.997V40.3548H317.23V0Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.23 0V-1.12097H316.11V0H317.23ZM317.23 1.12097H555.997V-1.12097H317.23V1.12097ZM318.351 40.3548V0H316.11V40.3548H318.351Z",
    fill: "#A6A6A6",
    mask: "url(#path-9-inside-3_1618_12929)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-4_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.348 0H555.993V40.3548H318.348V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.348 0H555.993V40.3548H318.348V0Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.348 1.12097H555.993V-1.12097H318.348V1.12097Z",
    fill: "#A6A6A6",
    mask: "url(#path-11-inside-4_1618_12929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.174 12.4089H348.976L352.742 21.6218H352.899L356.665 12.4089H359.467V25.0898H357.278V16.3673H357.155L353.635 25.0548H352.006L348.486 16.3323H348.38V25.0898H346.174V12.4089ZM361.272 22.41C361.272 20.2732 363.041 19.6426 364.81 19.5376C365.466 19.4938 366.833 19.4149 367.244 19.3974V18.6443C367.244 17.6985 366.631 17.1555 365.528 17.1555C364.529 17.1555 363.916 17.6109 363.741 18.294H361.587C361.744 16.6826 363.198 15.4565 365.58 15.4565C367.384 15.4565 369.469 16.1922 369.469 18.7319V25.0898H367.332V23.7762H367.262C366.841 24.5819 365.948 25.2825 364.459 25.2825C362.638 25.2825 361.272 24.2841 361.272 22.41ZM363.426 22.3925C363.426 23.2157 364.091 23.6361 365.037 23.6361C366.386 23.6361 367.262 22.7428 367.262 21.6744V20.8862C366.85 20.9125 365.607 21.0001 365.16 21.0263C364.091 21.1139 363.426 21.5518 363.426 22.3925ZM373.812 19.52V25.0898H371.57V15.5791H373.707V17.1905H373.83C374.268 16.1221 375.231 15.4565 376.65 15.4565C378.629 15.4565 379.925 16.7526 379.908 19.0296V25.0898H377.683V19.3799C377.683 18.1013 377 17.3482 375.827 17.3482C374.636 17.3482 373.812 18.1363 373.812 19.52ZM381.607 22.41C381.607 20.2732 383.376 19.6426 385.145 19.5376C385.801 19.4938 387.168 19.4149 387.579 19.3974V18.6443C387.579 17.6985 386.966 17.1555 385.863 17.1555C384.864 17.1555 384.251 17.6109 384.076 18.294H381.922C382.08 16.6826 383.533 15.4565 385.915 15.4565C387.719 15.4565 389.804 16.1922 389.804 18.7319V25.0898H387.667V23.7762H387.597C387.176 24.5819 386.283 25.2825 384.794 25.2825C382.973 25.2825 381.607 24.2841 381.607 22.41ZM383.761 22.3925C383.761 23.2157 384.427 23.6361 385.372 23.6361C386.721 23.6361 387.597 22.7428 387.597 21.6744V20.8862C387.185 20.9125 385.942 21.0001 385.495 21.0263C384.427 21.1139 383.761 21.5518 383.761 22.3925ZM396.057 28.8556C393.534 28.8556 391.941 27.7346 391.783 25.9481H394.007C394.165 26.7713 394.953 27.1741 396.092 27.1741C397.423 27.1741 398.299 26.5961 398.299 25.1949V23.3734H398.193C397.843 24.074 397.09 24.9497 395.444 24.9497C393.254 24.9497 391.52 23.3558 391.52 20.2557C391.52 17.1205 393.254 15.4565 395.461 15.4565C397.143 15.4565 397.843 16.4549 398.193 17.138H398.299V15.5791H400.505V25.2475C400.505 27.6821 398.631 28.8556 396.057 28.8556ZM396.057 23.1982C397.493 23.1982 398.316 22.1123 398.316 20.2907C398.316 18.4866 397.51 17.2781 396.057 17.2781C394.568 17.2781 393.797 18.5567 393.797 20.2907C393.797 22.0422 394.585 23.1982 396.057 23.1982ZM406.863 25.2825C403.991 25.2825 402.239 23.3734 402.239 20.3958C402.239 17.4533 404.026 15.4565 406.741 15.4565C409.07 15.4565 411.085 16.9103 411.085 20.2557V20.9563H404.446C404.473 22.5764 405.427 23.531 406.881 23.531C407.862 23.531 408.527 23.1106 408.808 22.5502H410.997C410.594 24.1966 409.07 25.2825 406.863 25.2825ZM404.464 19.4325H408.948C408.93 18.1363 408.072 17.1905 406.776 17.1905C405.427 17.1905 404.534 18.2152 404.464 19.4325ZM412.819 25.0898V15.5791H414.955V17.1905H415.078C415.463 16.1046 416.427 15.4565 417.688 15.4565C418.984 15.4565 419.895 16.1046 420.262 17.1905H420.368C420.788 16.1396 421.839 15.4565 423.223 15.4565C424.957 15.4565 426.183 16.5775 426.183 18.6968V25.0898H423.958V19.0471C423.958 17.8561 423.24 17.3306 422.329 17.3306C421.226 17.3306 420.595 18.0838 420.595 19.1522V25.0898H418.423V18.9596C418.423 17.9787 417.758 17.3306 416.812 17.3306C415.849 17.3306 415.06 18.1188 415.06 19.3099V25.0898H412.819ZM432.541 25.2825C429.668 25.2825 427.917 23.3734 427.917 20.3958C427.917 17.4533 429.703 15.4565 432.418 15.4565C434.747 15.4565 436.762 16.9103 436.762 20.2557V20.9563H430.123C430.15 22.5764 431.104 23.531 432.558 23.531C433.539 23.531 434.205 23.1106 434.485 22.5502H436.674C436.271 24.1966 434.747 25.2825 432.541 25.2825ZM430.141 19.4325H434.625C434.607 18.1363 433.749 17.1905 432.453 17.1905C431.104 17.1905 430.211 18.2152 430.141 19.4325ZM440.738 19.52V25.0898H438.496V15.5791H440.633V17.1905H440.755C441.193 16.1221 442.156 15.4565 443.575 15.4565C445.554 15.4565 446.85 16.7526 446.833 19.0296V25.0898H444.608V19.3799C444.608 18.1013 443.925 17.3482 442.752 17.3482C441.561 17.3482 440.738 18.1363 440.738 19.52ZM453.716 15.5791V17.2956H451.842V22.2349C451.842 23.1457 452.298 23.3383 452.858 23.3383C453.121 23.3383 453.559 23.3208 453.839 23.3033V25.1249C453.576 25.1774 453.138 25.2124 452.578 25.2124C450.896 25.2124 449.6 24.3892 449.618 22.6027V17.2956H448.252V15.5791H449.618V13.3022H451.842V15.5791H453.716ZM459.689 25.0898V15.5791H461.861V17.1555H461.966C462.299 16.0696 463.227 15.439 464.313 15.439C464.558 15.439 464.909 15.4565 465.119 15.4916V17.5583C464.926 17.4883 464.453 17.4182 464.085 17.4182C462.842 17.4182 461.931 18.2765 461.931 19.485V25.0898H459.689ZM470.356 25.2825C467.483 25.2825 465.732 23.3734 465.732 20.3958C465.732 17.4533 467.518 15.4565 470.233 15.4565C472.563 15.4565 474.577 16.9103 474.577 20.2557V20.9563H467.939C467.965 22.5764 468.919 23.531 470.373 23.531C471.354 23.531 472.02 23.1106 472.3 22.5502H474.489C474.086 24.1966 472.563 25.2825 470.356 25.2825ZM467.956 19.4325H472.44C472.423 18.1363 471.564 17.1905 470.268 17.1905C468.919 17.1905 468.026 18.2152 467.956 19.4325ZM482.669 28.6629V23.5835H482.581C482.231 24.2841 481.495 25.265 479.849 25.265C477.607 25.265 475.926 23.4785 475.926 20.3432C475.926 17.173 477.66 15.4565 479.866 15.4565C481.548 15.4565 482.248 16.4549 482.581 17.138H482.704V15.5791H484.893V28.6629H482.669ZM480.462 23.4259C481.898 23.4259 482.721 22.1823 482.721 20.3257C482.721 18.4866 481.916 17.2781 480.462 17.2781C478.973 17.2781 478.203 18.5567 478.203 20.3257C478.203 22.1298 478.991 23.4259 480.462 23.4259ZM493.125 21.0964V15.5791H495.35V25.0898H493.195V23.4084H493.09C492.652 24.4593 491.654 25.2124 490.235 25.2124C488.361 25.2124 487.065 23.9163 487.048 21.6394V15.5791H489.29V21.2891C489.29 22.4976 490.008 23.2683 491.094 23.2683C492.074 23.2683 493.125 22.5502 493.125 21.0964ZM497.487 25.0898V15.5791H499.729V25.0898H497.487ZM498.625 14.2305C497.925 14.2305 497.329 13.6875 497.329 13.0044C497.329 12.3388 497.925 11.7959 498.625 11.7959C499.343 11.7959 499.921 12.3388 499.921 13.0044C499.921 13.6875 499.343 14.2305 498.625 14.2305ZM501.865 25.0898V15.5791H504.037V17.1555H504.142C504.475 16.0696 505.403 15.439 506.489 15.439C506.735 15.439 507.085 15.4565 507.295 15.4916V17.5583C507.102 17.4883 506.63 17.4182 506.262 17.4182C505.018 17.4182 504.107 18.2765 504.107 19.485V25.0898H501.865ZM512.532 25.2825C509.66 25.2825 507.908 23.3734 507.908 20.3958C507.908 17.4533 509.695 15.4565 512.41 15.4565C514.739 15.4565 516.753 16.9103 516.753 20.2557V20.9563H510.115C510.141 22.5764 511.096 23.531 512.55 23.531C513.53 23.531 514.196 23.1106 514.476 22.5502H516.666C516.263 24.1966 514.739 25.2825 512.532 25.2825ZM510.133 19.4325H514.616C514.599 18.1363 513.741 17.1905 512.445 17.1905C511.096 17.1905 510.203 18.2152 510.133 19.4325ZM522.025 25.265C519.783 25.265 518.102 23.4785 518.102 20.3432C518.102 17.173 519.836 15.4565 522.043 15.4565C523.724 15.4565 524.425 16.4549 524.758 17.138H524.845V12.4089H527.07V25.0898H524.88V23.5835H524.758C524.407 24.2841 523.672 25.265 522.025 25.265ZM522.638 23.4259C524.075 23.4259 524.898 22.1823 524.898 20.3257C524.898 18.4866 524.092 17.2781 522.638 17.2781C521.15 17.2781 520.379 18.5567 520.379 20.3257C520.379 22.1298 521.167 23.4259 522.638 23.4259Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1618_12929)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 40.3548,
    transform: "translate(0 40.3555)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-5_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40.3555H79.4286V80.7103H0V40.3555Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 40.3555H79.4286V80.7103H0V40.3555Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 40.3555V39.2345H-1.12097V40.3555H0ZM0 41.4764H79.4286V39.2345H0V41.4764ZM1.12097 80.7103V40.3555H-1.12097V80.7103H1.12097Z",
    fill: "#A6A6A6",
    mask: "url(#path-14-inside-5_1618_12929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0621 64.4968C35.0621 62.0337 37.2296 61.482 39.0819 61.344C39.7617 61.2948 41.4957 61.2061 41.9784 61.1864V60.3194C41.9784 58.9598 41.1705 58.1716 39.5548 58.1716C38.1952 58.1716 37.3873 58.8022 37.1508 59.61H35.3774C35.5942 57.8957 37.269 56.6938 39.6336 56.6938C41.0326 56.6938 43.6533 57.1076 43.6533 60.477V67.5312H41.9784V66.0731H41.8996C41.5449 66.8022 40.5597 67.7874 38.7075 67.7874C36.6779 67.7874 35.0621 66.5854 35.0621 64.4968ZM36.7567 64.5756C36.7567 65.6987 37.7025 66.2702 39.003 66.2702C40.9144 66.2702 41.9784 64.9894 41.9784 63.6495V62.5657C41.476 62.6051 39.7912 62.7332 39.2789 62.7628C37.742 62.8613 36.7567 63.413 36.7567 64.5756Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-6_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.4336 40.3555H158.862V80.7103H79.4336V40.3555Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.4336 40.3555H158.862V80.7103H79.4336V40.3555Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4336 40.3555V39.2345H78.3126V40.3555H79.4336ZM79.4336 41.4764H158.862V39.2345H79.4336V41.4764ZM80.5546 80.7103V40.3555H78.3126V80.7103H80.5546Z",
    fill: "#A6A6A6",
    mask: "url(#path-17-inside-6_1618_12929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.725 67.5352V53.2691H116.419V58.5302H116.557C116.932 57.9588 117.562 56.6977 119.651 56.6977C122.331 56.6977 124.222 58.8258 124.222 62.2149C124.222 65.6041 122.331 67.7519 119.671 67.7519C117.621 67.7519 116.932 66.4908 116.557 65.8997H116.36V67.5352H114.725ZM116.38 62.1755C116.38 64.5795 117.464 66.2347 119.414 66.2347C121.444 66.2347 122.508 64.4613 122.508 62.1755C122.508 59.9489 121.483 58.2149 119.414 58.2149C117.444 58.2149 116.38 59.811 116.38 62.1755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-7_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.855 40.3555H238.284V80.7103H158.855V40.3555Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.855 40.3555H238.284V80.7103H158.855V40.3555Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.855 40.3555V39.2345H157.735V40.3555H158.855ZM158.855 41.4764H238.284V39.2345H158.855V41.4764ZM159.976 80.7103V40.3555H157.735V80.7103H159.976Z",
    fill: "#A6A6A6",
    mask: "url(#path-20-inside-7_1618_12929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.804 67.7519C195.77 67.7519 193.918 65.4465 193.918 62.2346C193.918 58.9834 195.849 56.6977 198.765 56.6977C201.051 56.6977 202.745 58.0376 203.021 60.0671H201.327C201.09 59.0819 200.223 58.1952 198.804 58.1952C196.893 58.1952 195.612 59.7716 195.612 62.1755C195.612 64.6583 196.854 66.2347 198.804 66.2347C200.065 66.2347 201.031 65.5647 201.327 64.3824H203.021C202.745 66.2938 201.189 67.7519 198.804 67.7519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-8_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.275 40.3555H317.704V80.7103H238.275V40.3555Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.275 40.3555H317.704V80.7103H238.275V40.3555Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.275 40.3555V39.2345H237.154V40.3555H238.275ZM238.275 41.4764H317.704V39.2345H238.275V41.4764ZM239.396 80.7103V40.3555H237.154V80.7103H239.396Z",
    fill: "#A6A6A6",
    mask: "url(#path-23-inside-8_1618_12929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.389 67.7519C274.729 67.7519 272.838 65.6041 272.838 62.2149C272.838 58.8258 274.729 56.6977 277.409 56.6977C279.478 56.6977 280.148 57.9588 280.503 58.5302H280.621V53.2691H282.335V67.5352H280.68V65.8997H280.503C280.128 66.4908 279.439 67.7519 277.389 67.7519ZM277.626 66.2347C279.576 66.2347 280.68 64.5795 280.68 62.1755C280.68 59.811 279.616 58.2149 277.626 58.2149C275.576 58.2149 274.552 59.9489 274.552 62.1755C274.552 64.4613 275.596 66.2347 277.626 66.2347Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-9_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.711 40.3555H397.141V80.7103H317.711V40.3555Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.711 40.3555H397.141V80.7103H317.711V40.3555Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.711 40.3555V39.2345H316.59V40.3555H317.711ZM317.711 41.4764H397.141V39.2345H317.711V41.4764ZM318.832 80.7103V40.3555H316.59V80.7103H318.832Z",
    fill: "#A6A6A6",
    mask: "url(#path-26-inside-9_1618_12929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.278 67.7519C354.184 67.7519 352.273 65.5647 352.273 62.2741C352.273 58.9834 354.204 56.6977 357.12 56.6977C359.367 56.6977 361.731 58.077 361.731 62.0376V62.747H353.968C354.046 65.013 355.367 66.2544 357.278 66.2544C358.559 66.2544 359.367 65.7026 359.761 65.0327H361.574C361.061 66.6485 359.485 67.7519 357.278 67.7519ZM353.987 61.3085H360.017C360.017 59.5154 358.874 58.1952 357.12 58.1952C355.268 58.1952 354.086 59.6534 353.987 61.3085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-10_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.145 40.3555H476.574V80.7103H397.145V40.3555Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M397.145 40.3555H476.574V80.7103H397.145V40.3555Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.145 40.3555V39.2345H396.024V40.3555H397.145ZM397.145 41.4764H476.574V39.2345H397.145V41.4764ZM398.265 80.7103V40.3555H396.024V80.7103H398.265Z",
    fill: "#A6A6A6",
    mask: "url(#path-29-inside-10_1618_12929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.507 56.8356V58.2543H437.143V67.5352H435.428V58.2543H433.714V56.8356H435.428V55.3775C435.428 53.6435 436.591 52.5991 438.483 52.5991C438.896 52.5991 439.389 52.6583 439.744 52.7174V54.2346C439.389 54.1755 439.074 54.1558 438.857 54.1558C437.675 54.1558 437.143 54.6484 437.143 55.7519V56.8356H439.507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-32-inside-11_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.572 40.3555H556.002V80.7103H476.572V40.3555Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.572 40.3555H556.002V80.7103H476.572V40.3555Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.572 40.3555V39.2345H475.451V40.3555H476.572ZM476.572 41.4764H556.002V39.2345H476.572V41.4764ZM477.693 80.7103V40.3555H475.451V80.7103H477.693Z",
    fill: "#A6A6A6",
    mask: "url(#path-32-inside-11_1618_12929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.982 71.7716C513.4 71.7716 511.647 70.6485 511.45 68.6583H513.223C513.46 69.7421 514.464 70.2938 515.982 70.2938C517.814 70.2938 518.937 69.5056 518.937 67.7322V65.5647H518.799C518.445 66.1558 517.755 67.3775 515.686 67.3775C513.085 67.3775 511.134 65.4071 511.134 62.0376C511.134 58.7469 513.026 56.6977 515.706 56.6977C517.775 56.6977 518.445 57.9588 518.839 58.5302H518.977V56.8356H520.632V67.8307C520.632 70.5894 518.583 71.7716 515.982 71.7716ZM515.923 65.8603C517.873 65.8603 518.977 64.4613 518.977 62.0967C518.977 59.811 517.913 58.2149 515.923 58.2149C513.873 58.2149 512.849 59.9489 512.849 62.0967C512.849 64.3233 513.893 65.8603 515.923 65.8603Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1618_12929)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 69.5,
    transform: "translate(0 80.7109)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-12_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 80.7109H80.7097V150.211H0V80.7109Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 80.7109H80.7097V150.211H0V80.7109Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 80.7109V79.59H-1.12097V80.7109H0ZM80.7097 80.7109H81.8306V79.59H80.7097V80.7109ZM0 81.8319H80.7097V79.59H0V81.8319ZM79.5887 80.7109V150.211H81.8306V80.7109H79.5887ZM1.12097 150.211V80.7109H-1.12097V150.211H1.12097Z",
    fill: "#A6A6A6",
    mask: "url(#path-35-inside-12_1618_12929)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.9139,
    cy: 114.902,
    r: 16.8145,
    stroke: "#646464",
    strokeWidth: 3.3629
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-38-inside-13_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5898 80.7109H159.179V81.8319H79.5898V80.7109Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.5898 80.7109H159.179V81.8319H79.5898V80.7109Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5898 81.8319H159.179V79.59H79.5898V81.8319Z",
    fill: "#A6A6A6",
    mask: "url(#path-38-inside-13_1618_12929)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-40-inside-14_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.172 80.7109H317.228V150.211H159.172V80.7109Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.172 80.7109H317.228V150.211H159.172V80.7109Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.172 80.7109V79.59H158.051V80.7109H159.172ZM159.172 81.8319H317.228V79.59H159.172V81.8319ZM160.293 150.211V80.7109H158.051V150.211H160.293Z",
    fill: "#A6A6A6",
    mask: "url(#path-40-inside-14_1618_12929)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-42-inside-15_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.172 80.7109H238.761V150.211H159.172V80.7109Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.172 80.7109H238.761V150.211H159.172V80.7109Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.172 81.8319H238.761V79.59H159.172V81.8319Z",
    fill: "#A6A6A6",
    mask: "url(#path-42-inside-15_1618_12929)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.967,
    cy: 114.902,
    r: 16.8145,
    stroke: "#646464",
    strokeWidth: 3.3629
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.967 102.651C201.554 102.651 204.075 103.47 206.168 104.991C208.261 106.511 209.819 108.656 210.618 111.116C211.418 113.577 211.418 116.227 210.618 118.687C209.819 121.148 208.261 123.292 206.168 124.813L198.967 114.902L198.967 102.651Z",
    fill: "#F2CA88"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.433,
    cy: 114.902,
    r: 16.8145,
    stroke: "#646464",
    strokeWidth: 3.3629
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.434 102.651C280.021 102.651 282.542 103.47 284.635 104.991C286.728 106.511 288.286 108.656 289.085 111.116C289.885 113.577 289.885 116.227 289.085 118.687C288.286 121.148 286.728 123.292 284.635 124.813L277.434 114.902L277.434 102.651Z",
    fill: "#F2CA88"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-48-inside-16_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.23 80.7109H396.819V150.211H317.23V80.7109Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.23 80.7109H396.819V150.211H317.23V80.7109Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.23 80.7109V79.59H316.11V80.7109H317.23ZM317.23 81.8319H396.819V79.59H317.23V81.8319ZM318.351 150.211V80.7109H316.11V150.211H318.351Z",
    fill: "#A6A6A6",
    mask: "url(#path-48-inside-16_1618_12929)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.021,
    cy: 114.902,
    r: 16.8145,
    stroke: "#646464",
    strokeWidth: 3.3629
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.022 102.651C358.631 102.651 360.224 102.968 361.71 103.584C363.196 104.199 364.547 105.102 365.685 106.239C366.822 107.377 367.724 108.727 368.34 110.214C368.956 111.7 369.273 113.293 369.273 114.902C369.273 116.511 368.956 118.104 368.34 119.59C367.724 121.076 366.822 122.427 365.685 123.564C364.547 124.702 363.196 125.604 361.71 126.22C360.224 126.835 358.631 127.152 357.022 127.152L357.022 114.902L357.022 102.651Z",
    fill: "#F2CA88"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-52-inside-17_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.82 80.7109H476.409V150.211H396.82V80.7109Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.82 80.7109H476.409V150.211H396.82V80.7109Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.82 80.7109V79.59H395.699V80.7109H396.82ZM396.82 81.8319H476.409V79.59H396.82V81.8319ZM397.941 150.211V80.7109H395.699V150.211H397.941Z",
    fill: "#A6A6A6",
    mask: "url(#path-52-inside-17_1618_12929)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.613,
    cy: 114.902,
    r: 16.8145,
    stroke: "#646464",
    strokeWidth: 3.3629
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.614 102.651C438.547 102.651 440.453 103.109 442.176 103.986C443.898 104.864 445.388 106.137 446.525 107.701C447.661 109.265 448.411 111.076 448.714 112.985C449.016 114.895 448.862 116.849 448.265 118.687C447.667 120.526 446.643 122.197 445.276 123.564C443.909 124.931 442.238 125.955 440.399 126.553C438.561 127.15 436.607 127.304 434.697 127.002C432.788 126.699 430.977 125.949 429.413 124.813L436.614 114.902L436.614 102.651Z",
    fill: "#F2CA88"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-56-inside-18_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.41 80.7109H555.999V150.211H476.41V80.7109Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 80.7109H555.999V150.211H476.41V80.7109Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 80.7109V79.59H475.289V80.7109H476.41ZM476.41 81.8319H555.999V79.59H476.41V81.8319ZM477.531 150.211V80.7109H475.289V150.211H477.531Z",
    fill: "#A6A6A6",
    mask: "url(#path-56-inside-18_1618_12929)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.199,
    cy: 114.902,
    r: 16.8145,
    stroke: "#646464",
    strokeWidth: 3.3629
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.2 102.651C518.459 102.651 520.674 103.276 522.601 104.456C524.527 105.637 526.089 107.327 527.115 109.34C528.141 111.353 528.59 113.611 528.413 115.863C528.235 118.115 527.439 120.275 526.111 122.102C524.783 123.93 522.975 125.355 520.888 126.22C518.801 127.084 516.515 127.355 514.283 127.002C512.052 126.648 509.962 125.684 508.244 124.217C506.526 122.75 505.247 120.836 504.549 118.687L516.2 114.902L516.2 102.651Z",
    fill: "#F2CA88"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.387,
    cy: 114.902,
    r: 16.8145,
    stroke: "#646464",
    strokeWidth: 3.3629
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.638 114.903C131.638 113.294 131.321 111.701 130.705 110.215C130.09 108.729 129.187 107.378 128.05 106.24C126.912 105.103 125.562 104.201 124.075 103.585C122.589 102.969 120.996 102.652 119.387 102.652L119.387 114.903H131.638Z",
    fill: "#F2CA88"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1618_12929)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 104.25,
    transform: "translate(0 150.211)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-62-inside-19_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 150.211H79.5887V190.566H0V150.211Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 150.211H79.5887V190.566H0V150.211Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 150.211V149.09H-1.12097V150.211H0ZM0 151.332H79.5887V149.09H0V151.332ZM1.12097 190.566V150.211H-1.12097V190.566H1.12097Z",
    fill: "#A6A6A6",
    mask: "url(#path-62-inside-19_1618_12929)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-64-inside-20_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5898 150.211H159.179V254.461H79.5898V150.211Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.5898 150.211H159.179V254.461H79.5898V150.211Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5898 150.211V149.09H78.4689V150.211H79.5898ZM79.5898 151.332H159.179V149.09H79.5898V151.332ZM80.7108 254.461V150.211H78.4689V254.461H80.7108Z",
    fill: "#A6A6A6",
    mask: "url(#path-64-inside-20_1618_12929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4082 208.542C97.5579 198.699 100.409 178.677 102.617 177.34C103.077 176.969 104.134 176.783 104.686 179.012C105.376 182.541 107.032 193.387 108.135 208.542C108.365 213.742 109.239 224.143 110.895 224.143C111.124 224.514 112.826 223.028 117.793 214.114C118.713 212.999 120.828 211.551 121.932 214.671C122.392 215.414 123.725 216.231 125.381 213.557L128.14 208.542C128.6 207.613 129.934 206.313 131.589 208.542L133.659 210.544C134.809 211.658 137.936 212.772 141.247 208.315",
    stroke: "#66FCF1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.1969,
    y1: 209.073,
    x2: 146.703,
    y2: 209.073,
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeDasharray: "0.7 0.7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-68-inside-21_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.178 150.211H238.766V254.461H159.178V150.211Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.178 150.211H238.766V254.461H159.178V150.211Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.178 150.211V149.09H158.057V150.211H159.178ZM159.178 151.332H238.766V149.09H159.178V151.332ZM160.299 254.461V150.211H158.057V254.461H160.299Z",
    fill: "#A6A6A6",
    mask: "url(#path-68-inside-21_1618_12929)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.787,
    y1: 208.846,
    x2: 226.293,
    y2: 208.846,
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeDasharray: "0.7 0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.24 208.287C179.02 196.228 181.164 173.225 183.504 177.677C183.504 177.492 183.738 177.788 184.674 180.46C184.869 180.274 185.843 185.803 188.183 209.4C188.573 214.038 189.469 224.092 189.937 227.209C190.327 227.765 191.341 227.32 192.277 221.087C192.472 218.861 193.095 214.297 194.031 213.852C194.616 213.296 196.371 215.188 198.71 227.209C199.1 228.508 200.933 226.875 205.143 209.956C205.533 207.916 207.015 204.725 209.822 208.287C210.992 210.046 214.384 212.843 218.595 209.956",
    stroke: "#66FCF1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-72-inside-22_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.768 150.211H317.235V254.461H238.768V150.211Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.768 150.211H317.235V254.461H238.768V150.211Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.768 150.211V149.09H237.647V150.211H238.768ZM238.768 151.332H317.235V149.09H238.768V151.332ZM239.889 254.461V150.211H237.647V254.461H239.889Z",
    fill: "#A6A6A6",
    mask: "url(#path-72-inside-22_1618_12929)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.609,
    y1: 208.584,
    x2: 308.115,
    y2: 208.584,
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeDasharray: "0.7 0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.188 207.678C261.748 197.963 263.093 178.421 263.99 177.973C264.55 176.478 266.008 174.386 267.353 177.973C267.913 181.896 269.146 193.33 269.595 207.678C269.595 214.217 269.931 227.183 271.276 226.735C271.463 227.482 272.621 227.744 275.76 222.811C276.321 222.251 277.778 222.251 279.123 226.735C279.683 226.922 280.917 225.838 281.365 220.009C281.739 215.338 282.822 205.997 284.167 205.997C284.915 205.25 286.746 204.652 288.091 208.239C288.838 209.36 291.229 210.929 294.817 208.239",
    stroke: "#66FCF1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-76-inside-23_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.23 150.211H396.819V254.461H317.23V150.211Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.23 150.211H396.819V254.461H317.23V150.211Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.23 150.211V149.09H316.11V150.211H317.23ZM317.23 151.332H396.819V149.09H317.23V151.332ZM318.351 254.461V150.211H316.11V254.461H318.351Z",
    fill: "#A6A6A6",
    mask: "url(#path-76-inside-23_1618_12929)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.957,
    y1: 209.327,
    x2: 385.463,
    y2: 209.327,
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeDasharray: "0.7 0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.967 208.982C338.527 200.575 339.872 182.975 340.769 179.837C341.33 177.782 343.011 174.904 345.253 179.837C345.44 180.584 345.814 182.303 345.814 183.2C346 195.156 346.822 219.295 348.616 220.191C349.363 220.752 351.194 220.416 352.539 214.587C352.913 213.839 353.885 213.129 354.781 216.268C355.155 218.323 356.239 223.666 357.584 228.599C358.331 229.346 360.05 229.608 360.947 224.675C361.694 218.884 363.525 207.076 364.87 206.179C365.804 205.058 368.233 204.386 370.475 210.663C371.409 211.597 373.95 212.569 376.64 208.982",
    stroke: "#66FCF1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-80-inside-24_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.82 150.211H476.409V254.461H396.82V150.211Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.82 150.211H476.409V254.461H396.82V150.211Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.82 150.211V149.09H395.699V150.211H396.82ZM396.82 151.332H476.409V149.09H396.82V151.332ZM397.941 254.461V150.211H395.699V254.461H397.941Z",
    fill: "#A6A6A6",
    mask: "url(#path-80-inside-24_1618_12929)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.447,
    y1: 209.967,
    x2: 463.953,
    y2: 209.967,
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeDasharray: "0.7 0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.73 209.988C424.098 203.751 425.054 190.029 425.936 185.039C426.303 182.771 427.479 178.234 429.243 178.234C430.346 178.234 432.551 179.595 432.551 185.039C432.735 194.867 433.213 214.751 433.654 215.659C434.205 217.549 435.749 220.875 437.513 219.061C438.432 218.683 440.269 219.288 440.269 224.731C441.188 227.566 443.357 230.742 444.68 220.762C445.047 215.659 446.664 205.679 450.193 206.586C450.928 206.586 452.729 207.493 454.052 211.122C454.419 211.5 455.595 211.803 457.359 209.988",
    stroke: "#66FCF1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-84-inside-25_1618_12929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.41 150.211H555.999V254.461H476.41V150.211Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 150.211H555.999V254.461H476.41V150.211Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 150.211V149.09H475.289V150.211H476.41ZM476.41 151.332H555.999V149.09H476.41V151.332ZM477.531 254.461V150.211H475.289V254.461H477.531Z",
    fill: "#A6A6A6",
    mask: "url(#path-84-inside-25_1618_12929)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.019,
    y1: 207.725,
    x2: 543.526,
    y2: 207.725,
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeDasharray: "0.7 0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.195 206.82C502.943 197.478 504.549 178.571 504.998 177.675C505.932 175.059 508.361 171.509 510.603 178.235C510.976 179.356 511.948 188.1 512.845 214.106C513.031 215.601 513.853 218.254 515.647 216.909C516.768 215.601 519.122 214.891 519.57 222.513C519.757 226.997 521.028 234.059 524.615 226.437C526.296 220.271 529.771 207.716 530.22 206.82C531.154 205.138 533.807 203.009 536.945 207.941C537.506 208.501 538.963 209.062 540.308 206.82",
    stroke: "#66FCF1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.8512,
    y1: 208.846,
    x2: 69.3576,
    y2: 208.846,
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeDasharray: "0.7 0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2793 208.901C20.7958 200.102 22.4062 181.437 24.7162 177.17C24.7397 176.916 24.9557 177.391 25.6318 181.327C26.2656 189.156 27.5192 205.631 27.4629 208.901C27.862 214.998 29.0405 227.927 30.5617 230.864C30.7964 231.095 31.4772 230.726 32.3224 227.4C33.2849 220.864 35.731 207.419 37.8157 205.922C38.7782 204.906 40.8722 204.162 41.5483 209.317C41.7361 210.98 42.478 214.25 43.9429 214.028C44.4593 214.098 46.0134 213.114 48.0981 208.624C48.8963 207.169 51.1969 205.313 54.014 209.525C55.5399 211.488 59.6622 214.236 63.9442 209.525",
    stroke: "#66FCF1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.560484,
    y: 0.560484,
    width: 554.879,
    height: 253.339,
    rx: 3.92339,
    stroke: "#A6A6A6",
    strokeWidth: 1.12097
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1618_12929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 254.46,
    rx: 4.48387,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1618_12929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 40.3548,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1618_12929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 40.3548,
    fill: "white",
    transform: "translate(0 40.3555)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1618_12929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 69.5,
    fill: "white",
    transform: "translate(0 80.7109)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1618_12929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 104.25,
    fill: "white",
    transform: "translate(0 150.211)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnTable);
export default __webpack_public_path__ + "static/media/en_table.173c2086786699064e785a529ce42425.svg";
export { ForwardRef as ReactComponent };